import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Compass } from "lucide-react";

export const NotFound = () => (
  <section data-testid="not-found-page" className="soft-bg">
    <div className="mx-auto max-w-3xl px-4 py-24 sm:px-6 lg:px-8">
      <Compass className="h-10 w-10 text-[#1F8A8B]" aria-hidden />
      <p className="caption mt-6 text-[#0D9488]">Error 404</p>
      <h1 className="mt-3 text-4xl font-bold text-[#0B192C] sm:text-5xl">We couldn't find that page.</h1>
      <p className="mt-4 text-slate-600">The link may be out of date, or the page may have moved. Try one of these instead.</p>
      <div className="mt-10 flex flex-col gap-3 sm:flex-row">
        <Link to="/" data-testid="not-found-home-link" className="btn-teal">Back to home</Link>
        <Link to="/grants-funding" data-testid="not-found-funding-link" className="btn-ghost">Browse funding</Link>
        <Link to="/contact" data-testid="not-found-contact-link" className="btn-ghost">Contact us</Link>
      </div>
    </div>
  </section>
);

export const ThankYou = () => {
  const { state } = useLocation();
  return (
    <section data-testid="thank-you-page" className="soft-bg">
      <div className="mx-auto max-w-3xl px-4 py-24 sm:px-6 lg:px-8">
        <CheckCircle2 className="h-10 w-10 text-[#1F8A8B]" aria-hidden />
        <h1 className="mt-6 text-4xl font-bold text-[#0B192C] sm:text-5xl">Thank you, your message is on its way.</h1>
        <p className="mt-4 text-slate-600">Our team will reply by email, usually within [response time].</p>
        {state?.reference && <p className="mt-3 text-sm text-slate-500" data-testid="thank-you-reference">Your reference: <b>{state.reference}</b></p>}
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <Link to="/grants-funding" data-testid="thank-you-funding-link" className="btn-teal">Browse funding while you wait</Link>
          <Link to="/" data-testid="thank-you-home-link" className="btn-ghost">Back to home</Link>
        </div>
      </div>
    </section>
  );
};
